import type { ReactNode } from "react"
import { Label } from "@/components/ui/label"
import { cn } from "@/lib/utils"

export function FormField({ label, description, error, htmlFor, className, children }: {
  label?: ReactNode
  description?: ReactNode
  error?: string
  htmlFor?: string
  className?: string
  children: ReactNode
}) {
  return (
    <div className={cn("space-y-2", className)}>
      {label && <Label htmlFor={htmlFor} className="text-sm font-semibold">{label}</Label>}
      {children}
      {error ? <p className="text-xs font-medium text-destructive">{error}</p> : description ? <p className="text-xs leading-relaxed text-muted-foreground">{description}</p> : null}
    </div>
  )
}
